import React from "react";
import { useAuth } from "../hooks/useAuth";
import { Form } from "react-final-form";
import Hidden from "@material-ui/core/Hidden";
import { Routes } from "../../../constants/routes";
import FormLink from "../../../components/FormLink";
import Typography from "@material-ui/core/Typography";
import TextDivider from "../../../components/TextDivider";
import { registerTeacherFormValidator } from "../utils/validators/registerForm";
import makeStyles from "@material-ui/core/styles/makeStyles";
import RegisterTeacherForm from "./forms/RegisterTeacherForm";
import { texts } from "../constants/texts";
import { useWizard } from "../../wizard/context";
import { UserRole } from "../../user/enums/UserRole";

const useStyles = makeStyles(() => ({
  footer: {
    marginTop: 40,
  },
}));

export default function RegisterTeacherWidget() {
  const classes = useStyles();

  const {
    actions: { register },
  } = useAuth();

  const { openWizard } = useWizard();

  const openModal = () => {
    openWizard({
      steps: [
        {
          titleConfig: {
            titleText: "OOPS.",
          },
          content: texts.warningMessage,
        },
      ],
      submitButtonText: "Ok",
      cancelButtonText: null,
    });
  };

  function _submit(data) {
    const errors = registerTeacherFormValidator(data, openModal);

    if (
      Object.keys(errors).length > 1 ||
      Object.keys(errors.teacherProfile).length
    ) {
      return errors;
    }

    return register(data, UserRole.Teacher);
  }

  return (
    <>
      <Form onSubmit={_submit} component={RegisterTeacherForm} />

      <Hidden mdUp>
        <div className={classes.footer}>
          <TextDivider text={"OR"} />
          <Typography component="p" align="center">
            Already Registered?{" "}
            <FormLink to={`/${Routes.LOGIN}`}>Sign In</FormLink>
          </Typography>
        </div>
      </Hidden>
    </>
  );
}
